module.exports = __webpack_public_path__ + "img/purple-angle.6ad8751b.svg";